/**
 * OCHAT: los permisos de Meta que upstream no pide y Publicaciones Sociales necesita.
 *
 * Chatwoot conecta Facebook e Instagram solo para MENSAJERÍA, así que su lista
 * alcanza para leer y responder, pero no para publicar. Ochat publica, y sin estos
 * dos permisos la publicación falla del lado de Meta.
 *
 * Los dos requieren App Review de Meta. Hasta que estén concedidos, publicar da un
 * error de permisos mientras la mensajería sigue andando. Ver
 * docs/ochat/META-APP-REVIEW.md.
 *
 * `pages_read_engagement` no está acá porque ya lo pide la lista de upstream
 * (FACEBOOK_PAGE_SCOPES en dashboard/helper/facebookScopes.js, desde 4.17.1), y
 * Ochat lo necesita: es dependencia obligatoria de `pages_manage_posts`, lo pide
 * la publicación de Reels de Facebook y lo piden los comentarios. Si un merge lo
 * saca de la lista de upstream, hay que agregarlo acá. En 2026 Meta lo rechazó una
 * vez por pedirse sin ninguna función que lo usara; ver docs/ochat/META-APP-REVIEW.md.
 *
 * DÓNDE SE CONSUMEN
 * Los agrega `buildFacebookLoginScopes` en dashboard/helper/facebookScopes.js, que
 * es el único lugar donde upstream arma la lista. De ahí los heredan los dos
 * caminos que abren el diálogo de Meta: el alta de bandeja
 * (composables/useFacebookPageConnect.js) y la reautorización
 * (settings/inbox/facebook/Reauthorize.vue). Se agregó ahí y no en cada pantalla
 * justamente porque el composable no acepta un scope por parámetro.
 *
 * EL MODO DE FALLAR ES SILENCIOSO
 * Quien conecte o reautorice con la lista de upstream a secas conserva la
 * mensajería y pierde la publicación, sin ningún error en pantalla: el problema
 * aparece recién cuando falla una publicación programada. Pasó al mergear 4.17.1,
 * donde upstream refactorizó el scope a un helper y la resolución obvia
 * —quedarse con la de upstream— borraba estos dos permisos.
 */

/** Publicar en la página de Facebook. */
export const PAGE_PUBLISHING_SCOPE = 'pages_manage_posts';

/** Publicar en la cuenta de Instagram vinculada. */
export const INSTAGRAM_PUBLISHING_SCOPE = 'instagram_content_publish';

/** Los que aplican siempre, haya o no Instagram en la bandeja. */
export const OCHAT_PAGE_SCOPES = [PAGE_PUBLISHING_SCOPE];

/** Los que solo aplican si la bandeja tiene Instagram vinculado. */
export const OCHAT_INSTAGRAM_SCOPES = [INSTAGRAM_PUBLISHING_SCOPE];
